import { HttpClient } from '@/shared/lib/http-client';

export const fetchInsuranceIntermediaries = async() => {
  const response = await HttpClient.get('/insurance-intermediaries');

  return response.data?.data;
};
